/* eslint-disable */
import { Box, Button, Container, Typography } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

/** 新規有料プランの申込フォームは運用終了。導線はメール・アプリ・バナーから除去済み。 */
const PaidPlanSignupClosed = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Typography color="textPrimary" variant="h2" gutterBottom>
          有料プランお申込み
        </Typography>
        <Typography color="textSecondary" variant="body1" paragraph>
          現在、新規の有料プランお申込みを受け付けておりません。
        </Typography>
        <Button variant="contained" component={RouterLink} to="/login">
          ログインへ
        </Button>
      </Container>
    </Box>
  );
};

export default PaidPlanSignupClosed;
